import React from "react";
import { Link } from "react-router-dom"; // Import Link
import "./Blog.css"; 

// --- Standard Image Imports ---
import blogImg1 from "../assets/blog1.jpg"; 
import blogImg2 from "../assets/blog3.jpg"; 
import blogImg3 from "../assets/blog2.jpg"; 
import blogImg4 from "../assets/blog4.jpg"; 
import blogImg5 from "../assets/blog6.jpg"; 
import blogImg6 from "../assets/blog5.jpg"; 
import blogImg7 from "../assets/blog7.jpg"; 
import blogImg8 from "../assets/blog8.jpg"; 

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: "WEEKEND MINDSET, WEEKDAY OBLIGATIONS",
      date: "22.12.2025",
      image: blogImg1, 
    },
    {
      id: 2,
      title: "THE GUYS ARE WEARING ALO TOO AND LOOKING GOOD DOING IT",
      date: "22.12.2025",
      image: blogImg2,
    },
    {
      id: 3,
      title: "THIS 20 DEGREE NYC WEATHER HAS US FEELING LIKE WE NEED A BEACH VACATION",
      date: "22.12.2025",
      image: blogImg3,
    },
    {
      id: 4,
      title: "OUTFIT OF THE DAY: IT’S MONDAY",
      date: "22.12.2025",
      image: blogImg4,
    },
    // --- ROW 2 ---
    {
      id: 5,
      title: "TEXT THE GROUP CHAT, WE'RE GOING SKIING. LOCK IN YOUR LOOKS WITH QUICKFIT",
      date: "21.12.2025",
      image: blogImg5, 
    },
    {
      id: 6,
      title: "THE WINTER WEEKEND LOOK WE ALL WANT TO WEAR",
      date: "20.12.2025",
      image: blogImg6,
    },
    {
      id: 7,
      title: "LITTLE FRIDAY CALLED AND WE ANSWERED",
      date: "18.12.2025",
      image: blogImg7,
    },
    {
      id: 8,
      title: "OUTFIT OF THE DAY: MEN'S LOOKS",
      date: "25.11.2025",
      image: blogImg8,
    },
  ];

  return (
    <div className="blog-page">
      <div className="blog-header-container">
        <h1 className="blog-main-title">LATEST BLOG POSTS</h1>
      </div>

      <div className="blog-grid">
        {blogPosts.map((post) => (
          /* Change div to Link */
          <Link 
            key={post.id} 
            to="/signup" 
            className="blog-card"
          >
            <div className="blog-img-wrapper">
              <img src={post.image} alt={post.title} />
            </div>
            <div className="blog-content">
              <h3 className="blog-post-title">{post.title}</h3>
              <span className="blog-post-date">{post.date}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Blog;